import { fetchEndpoint } from '../server/network';
import XXTEA from './encryption'
import { SIGN_KEY, SHOP_CODE} from '@/util/env.js';
export default {
	fetch(key) {
		return JSON.parse(window.localStorage.getItem(key) || '[]')
	},
	// 中国时间转成日本时间
	getWeek(time) {
		var start_date = time.split(" ")[0];
		var start_time = time.split(" ")[1];
		var date;
		var dateArray = start_date.split("-");
		date = new Date(dateArray[0], parseInt(dateArray[1] - 1), dateArray[2]);
		var week = "日月火水木金土".charAt(date.getDay());
		return start_date + '(' + week + ')' + start_time
	},
	// 日期转化成时间戳
	getTimestamp(time) { //把时间日期转成时间戳
		// var a = Date.parse(new Date(time))/1000;
		return (new Date(time)).getTime() / 1000
		//  return a

	},
	// 把时间戳转化成日期+时间
	getDate(time){
		let date = new Date(time * 1000);
		 //时间戳为10位需*1000，时间戳为13位的话不需乘1000
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? ('0' + MM) : MM;//月补0
        let d = date.getDate();
        d = d < 10 ? ('0' + d) : d;//天补0
        let h = date.getHours();
        h = h < 10 ? ('0' + h) : h;//小时补0
        let m = date.getMinutes();
        m = m < 10 ? ('0' + m) : m;//分钟补0
        let s = date.getSeconds();
        s = s < 10 ? ('0' + s) : s;//秒补0
        return y + '-' + MM + '-' + d + ' ' + h + ':' + m+ ':' + s;
	},
	getTime(time) {
	  let date = new Date(time * 1000);
	  //时间戳为10位需*1000，时间戳为13位的话不需乘1000
	  let y = date.getFullYear();
	  let MM = date.getMonth() + 1;
	  MM = MM < 10 ? '0' + MM : MM; //月补0
	  let d = date.getDate();
	  d = d < 10 ? '0' + d : d; //天补0
	  let h = date.getHours();
	  h = h < 10 ? '0' + h : h; //小时补0
	  let m = date.getMinutes();
	  m = m < 10 ? '0' + m : m; //分钟补0
	  return y + '-' + MM + '-' + d + ' ' + h + ':' + m;
	},
	// 把时间戳转化成日期
	getDay(time) {
		let date = new Date(time * 1000);
		//时间戳为10位需*1000，时间戳为13位的话不需乘1000
		let y = date.getFullYear();
		let MM = date.getMonth() + 1;
		MM = MM < 10 ? ('0' + MM) : MM; //月补0
		let d = date.getDate();
		d = d < 10 ? ('0' + d) : d; //天补0
		return y + '-' + MM + '-' + d ;
	},
	// 转换成当前时间
	toLocalDate(dateString) {
		let diffSeconds = (new Date().getTimezoneOffset())* 60;
		let date = new Date(dateString);
		let utcTime = (date.getTime() / 1000) - 32400;
		return this.getDate(utcTime - diffSeconds);
	},
	// 二维码
	getQRcode(clientUrl, callback) {
		// 生成一个隐藏元素记录二维码
		var qrcodeDiv = document.createElement("div");
		qrcodeDiv.id = 'app-rqcode'
		qrcodeDiv.style.position = 'absolute'
		qrcodeDiv.style.top = '-999px'
		qrcodeDiv.style.left = '-999px'
		document.getElementById("app").appendChild(qrcodeDiv);
		// 生成二维码
		var qrcode = new QRCode(document.getElementById("app-rqcode"), {
			text: clientUrl,
			width: 200,
			height: 200,
			correctLevel: QRCode.CorrectLevel.H
		});
		var canvas_data = {}
		canvas_data.title = clientUrl;
		if (callback) {
			qrcodeDiv.style.border = '13px solid #fff'
			qrcodeDiv.style.float = 'left'
			// 如果需要生成带边框的二维码就生成图片
			html2canvas(qrcodeDiv).then((canvas) => {
				qrcodeDiv.parentNode.removeChild(qrcodeDiv); //删除元素避免污染
				canvas_data.url = canvas.toDataURL("image/png")
				callback(canvas_data)
			})
		} else {
			// 获取二维码的链接
			var canvas_code = document.getElementById("app-rqcode").firstElementChild
			canvas_data.url = canvas_code.toDataURL()
			qrcodeDiv.parentNode.removeChild(qrcodeDiv); //删除元素避免污染
			return canvas_data
		}
	},
	// 处理特殊字符
	getSymblo(str){
		if(typeof str=='string'){
			if(str.indexOf('+') != -1){
				str = str.replace(/\+/g,"%2B");
			}else if(str.indexOf('&') != -1){
				str = str.replace(/\&/g,"%26");
			}else if(str.indexOf('#') != -1){
				str = str.replace(/\#/g,"%23");
			}
		}else{
		}
		return str
	},
	//转换成Unicode编码
	encodeUnicode(str) {
		var res = [];
		for (var i = 0; i < str.length; i++) {
			res[i] = ("000" + str.charCodeAt(i).toString(16)).slice(-4);
		}
		return "\\u" + res.join("\\u");
	},
	//解码
	decodeUnicode(str) {
		str = str.replace(/\\/g, "%");
		return unescape(str);
	},

	getQuery(params){
		var query = JSON.parse(JSON.stringify(params));
		var is_q = false
		for ( var k in query.q) {
			if (query.q[k]) {
				if (Array.isArray(query.q[k])) {
					if (query.q[k].length) {
						query.q[k] = JSON.stringify(query.q[k])
						is_q = true
					}else{
						delete query.q[k]
					}
				}else{
					is_q = true
				}
			} else {
				delete query.q[k]
			}
		}
		if(is_q){
			query.q = JSON.stringify(query.q)
		}else {
			delete query.q
		}
		return query
	},
	// 数组排序
	compare(property) {
		return function (a, b) {
			var value1 = a[property];
			var value2 = b[property];
			return value1 - value2;
		}
	},
	// 当前时间
	currentDate(){
		var date = new Date(); //当前时间
		var month = this.zeroFill(date.getMonth() + 1); //月
		var day = this.zeroFill(date.getDate()); //日
		var hour = this.zeroFill(date.getHours()); //时
		var minute = this.zeroFill(date.getMinutes()); //分
		var second = this.zeroFill(date.getSeconds()); //秒
		var curTime = date.getFullYear() + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
		return curTime
	},
	zeroFill(i) {
	  if (i >= 0 && i <= 9) {
	    return "0" + i;
	  } else {
	    return i;
	  }
	},
	// 搜索文字显示高亮
	brightenKeyword(val, keyword) {
	   const Reg = new RegExp(keyword, 'i');
	   if (val) {
	     return val.replace(Reg, `<span style="color: #409EFF;">${keyword}</span>`);
	   }
	},
	// 数据加密
	getCncryption(params) {
		// let post_body = this.toQueryString(params);
		let post_body = params;
		let encry_post_body = '';
		let body = null;
		
		if (post_body && post_body.length) {
			encry_post_body = XXTEA.encryptToBase64(post_body, SHOP_CODE);
			// body = this.toQueryString({
			// 	x: encry_post_body
			// });  //转换特殊字符
			body = encry_post_body
			// body = body.replace(/\+/g, '%2B'); //转换特殊字符
		}
		return body;
	},
	toQueryString(obj) {
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
			if (Array.isArray(val) && val.length) {
				return val.sort().map(function (val2) {
					return key + '=' + encodeURIComponent(val2);
				}).join('&');
			}
			return key + '=' + encodeURIComponent(val);
		}).join('&') : '';
	},
	//将base64转换为文件
	dataURLtoFile(dataurl, filename) {
		var arr = dataurl.split(','),
			mime = arr[0].match(/:(.*?);/)[1],
			bstr = atob(arr[1]),
			n = bstr.length,
			u8arr = new Uint8Array(n);
		while (n--) {
			u8arr[n] = bstr.charCodeAt(n);
		}
		return new File([u8arr], filename, {
			type: mime
		});
	},
	//店铺区域拼接
	regionStr(item) {
		let region = "";
		for (let i = 0; i < item.region.length; i++) {
			let name = item.region[i].name[0].title;
			item.region[i].name.map(n => {
				if (n.code === "ja") {
					name = n.title;
				}
			});

			region = region + name;
		}
		return region;
	},
	// 动态cdn加载js
	loadScript(url, callback) {
		
		var script = document.createElement('script'),
			fn = callback || function () {};
		script.type = 'text/javascript';
		if (script.readyState) {
			script.onreadystatechange = function () {
				if (script.readyState == 'loaded' || script.readyState == 'complete') {
					script.onreadystatechange = null;
					fn('success');
				}
			};
		} else {
			//其他浏览器
			script.onload = function () {
				fn('success');
			};
			script.onerror = function () {
				fn('fail');
			}
		}
		script.src = url;
		document.getElementsByTagName('head')[0].appendChild(script);
	},
	another(obj) {
	  return JSON.parse(JSON.stringify(obj));
	}
	
	



}
